import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createSlug(name: string) {
  const slug = name
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+|-+$/g, ""); // Trim - from start and end of text
  return slug;
}

// Editors paste full YouTube URLs or IDs with leftover URL parameters
// (e.g. "5ngAyvqO2HE&ab" from "watch?v=5ngAyvqO2HE&ab_channel=…"), which the
// embed player refuses to load — so extract the plain 11-character ID first.
export function getYoutubeEmbedUrl(input?: string) {
  const value = input?.trim() || "";
  const id = (
    value.match(/(?:[?&]v=|youtu\.be\/|\/embed\/|\/shorts\/)([\w-]{11})/) ||
    value.match(/^([\w-]{11})/)
  )?.[1];

  return id
    ? `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&controls=0&playlist=${id}&enablejsapi=1`
    : "";
}

export function scrollTo(offset: number, callback: () => void) {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (window.pageYOffset.toFixed() === fixedOffset) {
      window.removeEventListener("scroll", onScroll);
      callback();
    }
  };

  window.addEventListener("scroll", onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: "smooth",
  });
}
